// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import Multiselect from 'vue-multiselect'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vueScrollto from 'vue-scrollto'
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/de.json';
import ToggleButton from 'vue-js-toggle-button'
import vueHeadful from 'vue-headful'
import Api from './services/Api'
import Notifications from 'vue-notification'

// COMPONENTS //
import PaginationComponent from '@/components/PaginationComponent'
import CancelModal from '@/components/Modals/CancelModal'
import ReturnModal from '@/components/Modals/ReturnModal'
import SupportModal from '@/components/Modals/SupportModal'
import EditAddressModal from '@/components/Modals/EditAddressModal'
import RefundModal from '@/components/Modals/RefundModal'
import RankingModal from '@/components/Modals/RankingModal'
import PriceInfoModal from '@/components/Modals/PriceInfoModal'
import BulkUpdateModal from '@/components/Modals/BulkUpdateModal'
import AddDeviceModal from '@/components/Modals/AddDeviceModal'
import ResTable from '@/components/Table'
import TopBar from '@/components/TopBar'
import Sidebar from '@/components/Sidebar'
import ControlSidebar from '@/components/ControlSidebar'
import ResourceRow from "./components/ResourceRow";
import EditRoleRow from "./components/EditRoleRow";
import AddRoleToUserRow from "./components/AddRoleToUserRow";
import LinksBox from './components/LinksBox'
// FILTERS //
import { domain, toLower, count, prettyDate, pluralize, capitalize, currency, translate, dateFormat2, dateFormat, toUpper, orderDate, orderTitle, country, percentage } from './filters'
import axios from "axios";
import TestShell from "./views/TestShell";

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});
Array.prototype.unique = function () {
  let arr = this
  return this.filter((e, i) => {
    return arr.indexOf(e) === i
  })
}
extend('password', {
  validate: (value) => {
    let regex = new RegExp('[0-z]{8,}$')
    return regex.test(value) && value.split('').unique().length >= 5
  },
  message: 'Password must be at least 8 characters and at least 5 of them have to be unique'
})

Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('capitalize', capitalize)
Vue.filter('currency', currency)
Vue.filter('translate', translate)
Vue.filter('dateFormat', dateFormat)
Vue.filter('dateFormat2', dateFormat2)
Vue.filter('toUpper', toUpper)
Vue.filter('orderDate', orderDate)
Vue.filter('orderTitle', orderTitle)
Vue.filter('country', country)
Vue.filter('percentage', percentage)
Vue.filter('toLower', toLower)
Vue.component('vue-headful', vueHeadful)
Vue.component('myPagination', PaginationComponent)
Vue.component('cancelModal', CancelModal)
Vue.component('returnModal', ReturnModal)
Vue.component('rankingModal', RankingModal)
Vue.component('priceInfoModal', PriceInfoModal)
Vue.component('bulkUpdateModal', BulkUpdateModal)
Vue.component('supportModal', SupportModal)
Vue.component('editModal', EditAddressModal)
Vue.component('refundModal', RefundModal)
Vue.component('Multiselect', Multiselect)
Vue.component('addDeviceModal', AddDeviceModal)
Vue.component('resTable', ResTable)
Vue.component('topBar', TopBar)
Vue.component('sidebar', Sidebar)
Vue.component('controlSidebar', ControlSidebar)
Vue.component('dateRangePicker', DateRangePicker)
Vue.component('resourceRow', ResourceRow)
Vue.component('editRoleRow', EditRoleRow)
Vue.component('addRoleToUserRow', AddRoleToUserRow)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('linksBox', LinksBox)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(vueScrollto)
Vue.use(ToggleButton)
Vue.use(Notifications)
Vue.mixin({
  methods: {
    formatBarDatasets: arr => {
      let newDatasets = []
      let colors = []
      arr.forEach(d => {
        d.data.forEach(ds => {
          //colors.push(`rgb(${Math.round(Math.random() * 255)}, ${Math.round(Math.random() * 255)}, ${Math.round(Math.random() * 255)})`)
          colors.push(`rgb(247,147,16)`)
        })
        d.borderColor = colors
        d.backgroundColor = colors
        newDatasets.push(d)
      })
      return newDatasets
    }
  }
})

router.beforeEach((to, from, next) => {
  let tooltip = document.getElementById('chartjs-tooltip')
  if (tooltip) {
    tooltip.remove()
  }
  store.commit('initialiseStore')
  if (to.path === '/login' && to.query.token) {
    store.commit('updateToken', to.query.token)
    Api().post('/getToken')
      .then(response => {
        store.commit('updatePermissions', response.data.permissions)
        store.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
        store.commit('updateLoggedInStatus', true)
        store.commit('updateUserAdmin', response.data.admin)
        axios.all([Api().get(`/accounting/user?id=${response.data.id}`), Api().get(`/company`), Api().get('/frontend/navigation/page/tree')])
          .then(axios.spread((...responses) => {
            store.commit('updateUser', responses[0].data)
            store.commit('updateRoles', responses[0].data.roles)
            store.commit('updateCompanies', responses[1].data)
            store.commit('updateNavTree', responses[2].data)
            let { routes } = router.options
            let routeData = routes.find(r => r.path === '/home')
            recursiveRouteCreator(responses[2].data[0].children, routeData.children, '')
            store.commit('updateRouteData', routeData)
            let activePage = routeData.children.filter(r => r.path.substr(0,6) !== '/admin' && r.path !== '/*')[0]
            store.commit('updateActivePage', activePage.id)
            next({path: (activePage.path)})
          }))
      })
      .catch(error => {
        this.loading = false
        let message = []
        Object.keys(error.response.data.errors).forEach(x => {
          message.push(error.response.data.errors[x][0])
        })
        let alert = {type: 'danger', dismiss: 4, message: message}
        this.alerts.push(alert)
      })
  } else {
    if (to.meta.auth && !store.getters.loggedInStatus) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  }
})
function recursiveRouteCreator (nav, target, parentName) {
  nav.forEach(n => {
    if (n.children.length > 0) {
      recursiveRouteCreator(n.children, target, getName(parentName, n.name.toLowerCase().split(' ').join('-')))
    } else {
      let routeData = {
        path: `/${getName(parentName, n.name.toLowerCase().split(' ').join('-'))}`,
        name: n.name.toLowerCase().split(' ').join('-'),
        component: TestShell,
        id: n.id
      }
      if (!target.find(r => r.path === routeData.path)) {
        target.push(routeData)
      }
    }
  })
}
function getName (parentName, n) {
  return parentName !== '' ? `${parentName}/${n}` : `${n}`
}
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('store', JSON.stringify(state))
})
export const bus = new Vue();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

